import { render, staticRenderFns } from "./ResourcesListNavItem.vue?vue&type=template&id=bfff0cca&"
import script from "./ResourcesListNavItem.vue?vue&type=script&lang=js&"
export * from "./ResourcesListNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports